/**
 * Counting the cash drawer.
 *
 * The notes and coins in circulation in Pakistan, largest first — which is the
 * order they come out of a drawer and the order anyone counts them in.
 *
 * The keys are what the backend's cash_counts table expects.
 */
export const DENOMINATIONS = Object.freeze([
  { key: 'd5000', value: 5000, label: 'Rs. 5000' },
  { key: 'd1000', value: 1000, label: 'Rs. 1000' },
  { key: 'd500', value: 500, label: 'Rs. 500' },
  { key: 'd100', value: 100, label: 'Rs. 100' },
  { key: 'd50', value: 50, label: 'Rs. 50' },
  { key: 'd20', value: 20, label: 'Rs. 20' },
  { key: 'd10', value: 10, label: 'Rs. 10' },
  { key: 'd5', value: 5, label: 'Rs. 5' },
]);

/**
 * Add up a counted drawer.
 *
 * Coins are entered as a total rather than counted individually — nobody
 * counts 200 one-rupee coins at the end of a shift, and insisting on it is how
 * you get a made-up number instead of a real one.
 *
 * @param {object} counts  { d5000: 2, d500: 3, ..., coins: 45 }
 * @returns {number}
 */
export function countTotal(counts = {}) {
  const notes = DENOMINATIONS.reduce((sum, note) => {
    const quantity = Number(counts[note.key]) || 0;
    // A negative count is a typo, not a debt. Ignoring it is better than
    // subtracting money from the drawer total.
    return sum + Math.max(0, Math.floor(quantity)) * note.value;
  }, 0);

  return notes + Math.max(0, Number(counts.coins) || 0);
}

/** Only the fields the backend stores, with everything defaulted. */
export function toPayload(counts = {}) {
  const payload = {};
  for (const note of DENOMINATIONS) {
    payload[note.key] = Math.max(0, Math.floor(Number(counts[note.key]) || 0));
  }
  payload.coins = Math.max(0, Number(counts.coins) || 0);
  return payload;
}
